<template>
    <div>
        <div class="row mb-2">
            <div class="col-md-4">
                <router-link :to="{name: 'customerCreate'}" class="btn btn-success btn-sm">{{$t('global.New')}}
                </router-link>
            </div>
            <div class="col-md-4">
                <button class="btn btn-outline-primary btn-sm pull-right">{{$t('global.Export')}}</button>
            </div>
        </div>
        <div class="card">
            <div class="card-body card-table">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                        enabled: true,
                        nextLabel: $t('table.NextLabel'),
                        prevLabel: $t('table.PrevLabel'),
                        rowsPerPageLabel: $t('table.RowsPerPageLabel'),
                        ofLabel: $t('table.OfLabel'),
                        pageLabel: $t('table.PageLabel'),
                        allLabel: $t('table.AllLabel')
                    }"
                        :rows="table.rows"
                        :styleClass="'table'+((!isCLoading) ? ' table-hover' : '')"
                        :totalRows="table.totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote">
                    <template slot="table-column" slot-scope="props">{{ $t('customer.'+props.column.label) }}</template>
                    <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                    <router-link
                            :to="{name: 'customerUpdate', params: {id: props.row.id}}">{{props.row.name}}</router-link>
                </span>
                        <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                    </template>
                    <div slot="emptystate">
                        <span v-if="isCLoading">
                            <loader-table></loader-table>
                        </span>
                        <span v-else>
                            {{$t('table.NoData')}}
                        </span>
                    </div>
                    <template slot="loadingContent">
                        <div class="spinner-border text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table'
    import {mapActions, mapGetters} from 'vuex'
    import loaderTable from '@/components/charts/loaders/loader-table.vue'
    import FilterGlobalInput from '@/components/FilterGlobalInput'

    export default {
        name: 'userIndex',
        data() {
            return {
                isLoading: false,
                isCLoading: true,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    }

                ]
            };
        },
        computed: mapGetters({
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
            loaderTable,
            FilterGlobalInput
        },
        async mounted() {
            this.$store.dispatch('TO_DEFAULTSTATE')
            await this.loadItems()
            this.isCLoading = false
        },
        methods: {
            ...mapActions({
                    loadItems: 'GET_CUSTOMERS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                let type = params[0].type
                let field = params[0].field

                this.updateParams({
                    sort: [{
                        type: type,
                        field: field,
                    }],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
        }
    }
</script>
